import axios from "axios";
import Config from "./Config";

const { API_BASE_URL } = Config;
const headers = {
  "Content-Type": "application/json",
};

// ---------------------------Blog ------------------------
// =========================Get All Blog=========================
export const getAllBlog = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/blog`, {
      headers,
    });
    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};

// ----------------------getBlogbySlug----------------
export const getBlogBySlug = async (Id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/blog/${Id}`, {
      headers,
    });

    if (response.data.status === true) {
      return response.data;
    } else {
      throw new Error(response.data.message); // Throw error with API message
    }
  } catch (error) {
    console.error(
      "Error fetching admin data:",
      error.response || error.message || error
    );
    throw error;
  }
};
